<div
  *ngIf="feed !== null || feed !== undefined"
  class="feedback"
  [className]="feed?.className"
  [ngStyle]="getFEEDStyles()"
  style="height: 100%"
>
  <form (ngSubmit)="submitFeedback(f)" #f="ngForm">
    <div class="feedback-trim">
      <div *ngIf="feed?.title" class="feedback-desc">
        <h3>{{ feed?.title }}</h3>
      </div>
      <div class="feedback-inputs">
        <div class="form-input" *ngIf="feed?.name">
          <input
            matInput
            id="feedback-name"
            type="text"
            placeholder="Enter Your Name"
            title="Enter Your Name"
            name="name"
            ngModel
            [ngStyle]="{ 'background-color': feed?.inputBack }"
          />
          <label for="feedback-name">
            <span [ngStyle]="{ color: feed?.labelColor }">Name (required)</span>
          </label>
        </div>
        <div class="form-input" *ngIf="feed?.email">
          <input
            id="feedback-email"
            type="email"
            placeholder="Enter Your Email"
            title="Enter Your Email"
            name="email"
            ngModel
            [ngStyle]="{ 'background-color': feed?.inputBack }"
          />
          <label for="feedback-email">
            <span [ngStyle]="{ color: feed?.labelColor }">Email (required)</span>
          </label>
        </div>
        <div class="form-input" *ngIf="feed?.phone">
          <input
            id="feedback-phone"
            type="tel"
            placeholder="Enter Your Phone"
            title="Enter Your Phone"
            name="phone"
            ngModel
            [ngStyle]="{ 'background-color': feed?.inputBack }"
          />
          <label for="feedback-phone">
            <span [ngStyle]="{ color: feed?.labelColor }">Phone</span>
          </label>
        </div>
        <div class="form-checkbox" *ngIf="feed?.emailCheckbox">
          <input
            type="checkbox"
            id="reply-checkbox"
            (click)="toggleEmail()"
            name="replyEmail"
            ngModel
            title="if reply Email is required"
            [ngStyle]="{ 'background-color': feed?.inputBack }"
          />
          <label for="reply-checkbox" [ngStyle]="{ color: feed?.labelColor }">
            Include Reply Email</label
          >
        </div>
      </div>
      <div class="feedback-story">
        <div class="feedback-select">
          <select
            name="option"
            [ngModel]="feedbackType"
            required="true"
            title="Choose a Feedback Option"
            [ngStyle]="{ color: feed?.labelColor, 'background-color': feed?.inputBack }"
          >
            <option [ngValue]="null" value="default" selected>
              -- Select an Option (required)--
            </option>
            <option value="suggestion">Suggestion</option>
            <option value="question">Questions</option>
            <option value="compliment">Compliment</option>
            <option value="complaint">Problems or Complaint</option>
          </select>
        </div>
        <div class="feedback-details">
          <textarea
            rows="3"
            [placeholder]="feed?.placeholder ? feed.placeholder : 'write us a message'"
            ngModel
            name="description"
            [attr.title]="feed?.placeholder ? feed.placeholder : 'write us a message'"
            [ngStyle]="{ color: feed?.labelColor, 'background-color': feed?.inputBack }"
          >
          </textarea>
        </div>
        <div class="feedback-buttons">
          <input
            *ngIf="feed?.resetButton"
            type="button"
            value="reset"
            title="Reset"
            class="btn btn-link"
            (click)="resetForm(f)"
            [disabled]="!f.touched"
          />
          <input
            type="submit"
            value="send"
            title="Send"
            [value]="feed?.sendButton ? feed?.sendButton : 'Send'"
            [ngClass]="feed?.btnClass ? feed?.btnClass : 'btn btn-primary'"
          />
        </div>
      </div>
    </div>
  </form>
</div>
